import { react2panel } from 'common/util/react2panel';
import { ChartCustomizationPanelReact } from './index';
export const ChartCustomizationPanelEl = react2panel("mp-chart-customization-panel", ChartCustomizationPanelReact, {
  contexts: ["segmentFilterController"]
});